export const XML_NAMESPACE = 'http://www.w3.org/XML/1998/namespace'

export const XMLNS_NAMESPACE = 'http://www.w3.org/2000/xmlns/'

export const CNXML_NAMESPACE = 'http://cnx.rice.edu/cnxml'

/** Natural language extensions to CNXML */
export const CMLNLE_NAMESPACE = 'http://katalysteducation.org/cmlnle/1.0'

export const CXLXT_NAMESPACE = 'http://katalysteducation.org/cxlxt/1.0'

/** CNXML extensions to facilitate better editing experience */
export const EDITING_NAMESPACE = 'http://adaptarr.naukosfera.com/editing/1.0'
